import detectVideoSupplier from './detectVideoSupplier';
const $ = jQuery.noConflict();

const customLightboxVideo = {
    init() {
        this.bindEvents();
        this.processCustomVideos();
    },

    bindEvents() {
        // Handle clicks on custom lightbox video elements
        $(document).on('click', '.custom-lightbox-video', (e) => {
            this.openCustomLightbox.call(this, e);
        });

        // Handle lightbox close
        $(document).on('click', '.custom-lightbox__close', (e) => {
            this.closeCustomLightbox.call(this, e);
        });

        // Handle escape key
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape' && $('.custom-lightbox').hasClass('active')) {
                this.closeCustomLightbox();
            }
        });

        // Handle background click to close
        $(document).on('click', '.custom-lightbox__overlay', (e) => {
            this.closeCustomLightbox.call(this, e);
        });
    },

    processCustomVideos() {
        $('.custom-lightbox-video').each((index, element) => {
            const $element = $(element);
            const videoUrl = $element.attr('data-video-url') || $element.text().trim();

            if (videoUrl && this.isValidVideoUrl(videoUrl)) {
                // Store the video URL as data attribute if not already set
                if (!$element.attr('data-video-url')) {
                    $element.attr('data-video-url', videoUrl);
                }

                // Ensure the element is clickable
                $element.addClass('custom-lightbox-video--clickable');
            }
        });
    },

    isValidVideoUrl(url) {
        return detectVideoSupplier.isYT(url) ||
               detectVideoSupplier.isVimeo(url) ||
               detectVideoSupplier.isWistia(url);
    },

    openCustomLightbox(e) {
        e.preventDefault();
        const $element = $(e.currentTarget);
        const videoUrl = $element.attr('data-video-url');

        if (!videoUrl) return;

        // Create lightbox HTML
        const lightboxHtml = this.createLightboxHtml(videoUrl);

        // Add to body
        $('body').append(lightboxHtml);

        // Show lightbox
        $('.custom-lightbox').addClass('active');

        // Lock scroll
        $('body').addClass('lightbox-open');

        // Focus on close button for accessibility
        $('.custom-lightbox__close').focus();
    },

    createLightboxHtml(videoUrl) {
        const embedUrl = this.getEmbedUrl(videoUrl);
        const videoId = this.getVideoId(videoUrl);

        return `
            <div class="custom-lightbox">
                <div class="custom-lightbox__overlay"></div>
                <div class="custom-lightbox__container">
                    <button class="custom-lightbox__close" aria-label="Close video">
                        <span class="icon-close"></span>
                    </button>
                    <div class="custom-lightbox__content">
                        <div class="custom-lightbox__video-container">
                            <iframe
                                src="${embedUrl}"
                                frameborder="0"
                                allowfullscreen
                                allow="autoplay; fullscreen; picture-in-picture"
                                data-video-id="${videoId}"
                                data-original-url="${videoUrl}"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        `;
    },

    getEmbedUrl(videoUrl) {
        if (detectVideoSupplier.isYT(videoUrl)) {
            const videoId = detectVideoSupplier.isYT(videoUrl);
            return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        } else if (detectVideoSupplier.isVimeo(videoUrl)) {
            const videoId = detectVideoSupplier.isVimeo(videoUrl);
            return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        } else if (detectVideoSupplier.isWistia(videoUrl)) {
            const videoId = detectVideoSupplier.isWistia(videoUrl);
            return `https://fast.wistia.net/embed/iframe/${videoId}?autoPlay=true`;
        }
        return videoUrl;
    },

    getVideoId(videoUrl) {
        if (detectVideoSupplier.isYT(videoUrl)) {
            return detectVideoSupplier.isYT(videoUrl);
        } else if (detectVideoSupplier.isVimeo(videoUrl)) {
            return detectVideoSupplier.isVimeo(videoUrl);
        } else if (detectVideoSupplier.isWistia(videoUrl)) {
            return detectVideoSupplier.isWistia(videoUrl);
        }
        return '';
    },

    closeCustomLightbox(e) {
        if (e) {
            e.preventDefault();
        }

        // Stop any playing videos
        $('.custom-lightbox iframe').each((index, iframe) => {
            iframe.src = '';
        });

        // Remove lightbox
        $('.custom-lightbox').remove();

        // Unlock scroll
        $('body').removeClass('lightbox-open');
    }
};

export default customLightboxVideo;
